<template>
    <div>
        <h3 class="mb-3">Total number of Sessions per channel</h3>
        <div class="no-data-placeholder" v-if="!this.channels.length">
            <img class="w-h-35 vertical-align-middle" src="../../assets/img/box.svg">
            <span class="vertical-align-middle mx-2 italic">
                No available results for this time period
            </span>
        </div>
        <apex-chart type="donut" :options="chartOptions" :series="series" ></apex-chart>
    </div>
</template>

<script>
    import apexChart from 'vue-apexcharts'
    export default {
        name: "total-sessions",
        components: {
            apexChart
        },
        props: {
            channels: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                series: [],
                chartOptions: {
                    plotOptions: {
                        pie: {
                            donut: {
                                labels: {
                                    show: true,
                                    value: {
                                        offsetY: -1,
                                        show: true
                                    },
                                    total: {
                                        show: true,
                                        label: 'Total Sessions',
                                        color: '#000'
                                    }
                                },
                            }
                        }
                    },
                    labels: [],
                    chart: {
                        type: 'donut'
                    }
                }
            }
        },
        mounted() {
        },
        watch: {
            channels() {
                this.series = []
                this.chartOptions.labels = []
                let labels = []
                for (let i=0;i<this.channels.length;i++) {
                    this.series.push(this.channels[i].data.sessions.total)
                    labels.push(this.channels[i].name)
                }
                this.chartOptions= {
                    labels: labels
                }
            }
        }
    }
</script>

<style scoped>

</style>